<template>
  <div class="page-wrapper-secondary">
    <div class="activity-container flex-container f-between f-wrap">
      <div class="flex-half">
        <div class="page-content">
          <h1 class="page-title">Деятельность</h1>

          <div class="content-text">
            <p>
              Портфель компании составляют объекты жилой и коммерческой недвижимости,
              которые включают в себя весь спектр товаров и услуг. Первые этажи наших жилых 
              комплексов будут составлять продуктовые магазины, магазины одежды, 
              а также кафе и рестораны. Для любителей спорта будут иметься фитнес залы.
            </p>
            <p>
              Также в пределах наших жилых комплексов будут расположены парковочные зоны 
              наземного и подземного типа, объекты социального и культурного назначения, 
              а именно площадки, предназначенные для детских игр и прогулок, а также беседки для отдыха. 
              Вся территория жилых комплексов будет охраняться 24/7.  Будет установлено видеонаблюдение, 
              а также контрольно-пропускные пункты, которые обеспечат вашу безопасность.
            </p>
            <p>
              Благодаря высокому профессиональному уровню управления строительством, применению 
              современных строительных решений, новейших производственных технологий, 
              а также использованию первоклассного штата сотрудников, возведение объектов выполняется 
              в запланированные сроки при оптимальной стоимости строительства. 
            </p>
            <p>
              Мы предлагаем качественно построенные объекты с продуманным генпланом, современными техническими 
              узлами и грамотной планировкой апартаментов. Обращаясь к нам, Вы получаете высококачественное жилье, 
              построенное профессионалами своего дела, которые имеют за плечами многолетний опыт в проектировании 
              и создании домов по европейским стандартам. Строительство производится под чутким руководством 
              и наблюдением профессионалов, имеющих за плечами не один десяток лет опыта и высшее строительное образование. 
              Гарантия на наши дома составляет 10 лет, в реальности срок эксплуатации наших домов более 60 лет.
            </p>
          </div>
        </div>
      </div>
      <div class="flex-half">
        <div class="content-slider">
          <carousel
            :per-page="1"
            :mouse-drag="true"
            :navigationEnabled="false"
            :paginationEnabled="false"
            :loop="true"
            :autoplay="true"
          >
            <slide>
              <div class="content-slider__item vh-100">
                <img src="img/hero-slider-img-1.jpg" class="d-block img-cover" />
              </div>
            </slide>
          </carousel>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import BreadCrumb from "../../components/BreadCrumb";
export default {
  components: {
    BreadCrumb
  }
};
</script>

<style></style>
